import React from "react";
import BurgerMenu from "./burgerMenu";

function Header({ username, onLogout }) {
  return (
    <header className="fixed top-0 left-0 right-0 z-10 bg-gray-300 text-white p-4 h-16">
      <div className="absolute left-0 top-0 z-10">
        <BurgerMenu onLogout={onLogout} />
      </div>

      <div className="flex-grow text-center">
        <a
          href="https://hvesi.hvv.ee/"
          target="_self"
          className="inline-block hover:opacity-80 transition-opacity duration-200"
          title="Mine hvesi keskkonda"
        >
          <img
            src="https://www.hvv.ee/wp-content/themes/ut-gogreen/img/logo/logo_small.png"
            alt="Logo"
            className="h-8 mx-auto cursor-pointer"
          />
        </a>
      </div>
    </header>
  );
}

export default Header;
